import { FunctionComponent } from "react";

import { EM_SPACE, formatDateTime } from "../../utils";

export type UpdateFooterProps = {
    timestamp: number,
    failedCount?: number,
    /** Set for a past year, whose results no longer change */
    finalYear?: number,
    onOpenDescription: () => void,
}

export const UpdateFooter: FunctionComponent<UpdateFooterProps> = ({ timestamp, failedCount, finalYear, onOpenDescription }) => finalYear !== undefined ? (
    <span style={{ opacity: 0.3 }}>
        Konečné výsledky ročníku {finalYear}
    </span>
) : (
    <>
        <span style={{ opacity: 0.3 }}>
            Aktualizováno {formatDateTime(timestamp)}
            {EM_SPACE}
            <span style={{ textDecoration: "underline", cursor: "pointer" }} onClick={onOpenDescription}>
                Proč?
            </span>
        </span>
        {failedCount && failedCount > 0 ? (
            <>
                <br />
                <span style={{ color: "var(--error-color)" }}>
                    Chyba u {failedCount} {failedCount === 1 ? "sportovce" : "sportovců"}.
                </span>
            </>
        ) : null}
    </>
);
